<template>
    <div>
        <template v-for="variation in variationListData">
            <p v-if="variation.variationId === currentVariation.variation.id && variation.stock.stockNet <= 10">
                Nur noch {{ variation.stock.stockNet }} auf Lager
            </p>
        </template>
    </div>
</template>

<script>
    export default {

        name: "stock",

        props: {
            variationListData: "",
            template: {
                type: String,
                default: "#vue-stock"
            }
        },

        inject: {
            itemId: {
                default: null
            }
        },

        computed: {
            currentVariation() {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            }
        },

        created() {
            this.$options.template = this.template;
        }
    }
</script>
